import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M18 1H2C.9 1 0 1.9 0 3v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM1 3c0-.551.449-1 1-1h8v11H1V3zm18 14c0 .551-.449 1-1 1H2c-.551 0-1-.449-1-1v-3h18v3zm0-4h-8V2h7c.551 0 1 .449 1 1v10z',
    'M6.813 4.109c-.216-.172-.53-.136-.703.078l-2 2.5a.5007.5007 0 0 0 0 .625l2 2.5a.5011.5011 0 0 0 .703.079c.215-.173.25-.487.078-.703L5.141 7l1.75-2.188a.5013.5013 0 0 0-.078-.703zM16.5 4h-3c-.275 0-.5.225-.5.5s.225.5.5.5h3c.275 0 .5-.225.5-.5s-.225-.5-.5-.5zM16.5 6h-3c-.275 0-.5.225-.5.5s.225.5.5.5h3c.275 0 .5-.225.5-.5s-.225-.5-.5-.5zM16.5 8h-3c-.275 0-.5.225-.5.5s.225.5.5.5h3c.275 0 .5-.225.5-.5s-.225-.5-.5-.5zM16.5 10h-3c-.275 0-.5.225-.5.5s.225.5.5.5h3c.275 0 .5-.225.5-.5s-.225-.5-.5-.5z',
  ],
  height: 20,
  width: 20,
});
